import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import authPic from "./images/burger.png";
import crmPic from "./images/burgerss.png";
import zohoPic from "./images/zoho_logo.png";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
// import CreateConnection from "./CreateConnection";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  Menu,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CreateConnection from "./CreateConnection/CreateConnection";
import { EXTENSION_IDENTIFIER } from "../../../config/serviceConstant";
import { getAllConnections } from "../../../APICalling/ServiceAPICalling";
import { Loader } from "../../atoms/Loader";
import ConnectionDetailsView from "./ConnectionDetailsView";
import { getSettings } from "../../../APICalling/OtherCalling";
import CustomConnection from "./CustomConnection/CustomConnection";
import DeleteOutlineTwoToneIcon from "@mui/icons-material/DeleteOutlineTwoTone";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import EditPage from "./EditPage";
import { useTheme } from "@emotion/react";

const fullText =
  "Connections created by you and the administrators of your organization are listed here. You can let other users of your organization utilize your connections. Changes made to such connections will also affect the users who utilize them.";

function ConnectionList({
  dataCenter,
  orgId,
  apiKey,
  zApiKey,
  activeUsers,
  currentUser,
  setSnack,
}) {
  const [loading, setLoading] = useState(true);
  const [connectionMap, setConnectionMap] = useState();
  const [connectionList, setConnectionList] = useState([]);
  const [connectionDetails, setConnectionDetails] = useState();
  const [list, setList] = useState("Connections");
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [connection, setConnection] = useState("list");
  const [searchText, setSearchText] = useState("");
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    const updateText = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 960) {
        // 'md' in Material-UI is typically 960px
        setDisplayText(
          fullText.length > 70 ? `${fullText.slice(0, 50)}...` : fullText
        );
      } else {
        setDisplayText(fullText);
      }
    };

    // Update text on component mount and window resize
    updateText();
    window.addEventListener("resize", updateText);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateText);
    };
  }, []);

  const handleClear = () => {
    setSearchText(""); // Clear the text field
  };

  const handleSearchClick = () => {
    // setShowSearchInput(!showSearchInput);
    setShowSearchInput((prev) => !prev);
  };

  const handleFilterClick = (e) => {
    setIsFilterOpen((prev) => !prev);
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setIsFilterOpen(false);
    setAnchorEl(null);
  };

  const handleChange = (event) => {
    setList(event.target.value);
  };

  const handlefetchConnections = async () => {
    try {
      setLoading((prev) => true);
      const headers = {
        connname: EXTENSION_IDENTIFIER,
        orgid: orgId,
        apikey: apiKey,
      };
      let connections = await getAllConnections({ headers });
      let tempConnectionMap = {};

      connections.forEach((connection) => {
        let connectionDataArray = connection?.service_name?.split("__");
        let serviceName = connectionDataArray[2];
        let serviceCustomConnName = connectionDataArray[3];
        let userEmail = connectionDataArray[4];
        if (userEmail) {
          let tempConnUser =
            tempConnectionMap?.[serviceCustomConnName]?.users || [];
          let users = [...tempConnUser, userEmail];
          tempConnectionMap[serviceCustomConnName] = {
            users: users,
          };
        }
      });

      let params = { settingType: "customConnection" };
      let connectionSettings = await getSettings({ headers, params });
      let tempConnectionList = connectionSettings?.data?.map((setting) => {
        let settingSchema = JSON.parse(setting?.setting_schema);
        return {
          ...settingSchema,
          users: tempConnectionMap[settingSchema?.data?.connApiName]?.users,
          settingId: setting?.setting_id,
        };
      });
      console.log({ tempConnectionList });
      setConnectionList((prev) => tempConnectionList);
      setConnectionMap((prev) => tempConnectionMap);
      setConnection((prev) => "list");
    } catch (error) {
      console.log({ error });
    }

    setLoading((prev) => false);
  };

  useEffect(() => {
    // call for all connection
    if (apiKey) {
      handlefetchConnections();
    }
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (connection === "list") {
    return (
      <Box p={5}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ width: "50%" }}>
            <FormControl variant="standard">
              <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
                My Connections
              </Typography>
            </FormControl>
            <Typography
              sx={{
                fontSize: "11px",
                color: "text.secondary",
                width: "98%",
              }}
            >
              {displayText}
            </Typography>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            gap={3}
            sx={{ position: "relative", flexShrink: 0 }} // Added flexShrink to prevent movement
          >
            <Box
              sx={{
                width: showSearchInput ? "200px" : "0px",
                transition: "width 0.3s ease",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                placeholder="Search here..."
                variant="outlined"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                InputProps={{
                  endAdornment: searchText && (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClear} edge="end" size="small">
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  opacity: showSearchInput ? 1 : 0,
                  transition: "opacity 0.3s ease 0.1s", // Adding a slight delay for smooth effect
                  width: "200px",
                }}
              />
            </Box>
            <IconButton
              sx={{
                backgroundColor: "#f5f7fa",
                borderRadius: 1,
                "&:hover": { backgroundColor: "#f0f0f0" },
                ml: 1,
              }}
              onClick={handleSearchClick}
            >
              <SearchIcon />
            </IconButton>

            {/* <div>
              <IconButton
                sx={{
                  backgroundColor: "#f5f7fa",
                  borderRadius: 1,
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
                onClick={(e) => handleFilterClick(e)}
              >
                {isFilterOpen ? <CloseIcon /> : <FilterListIcon />}
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl) && isFilterOpen}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom", // Anchor the menu below the button
                  horizontal: "left", // Align the menu to the left of the button
                }}
                transformOrigin={{
                  vertical: "top", // Ensure the menu opens upwards from the anchor point
                  horizontal: "left", // Align the menu from the left side of the anchor
                }}
                sx={{ mt: 1 }}
              >
                <MenuItem onClick={handleClose}>
                  <Typography>All</Typography>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <Typography>Connected</Typography>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <Typography>Not Connected</Typography>
                </MenuItem>
              </Menu>
            </div> */}

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0066FF",
                color: "#fff",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#0056d2",
                },
              }}
              onClick={() => {
                setConnection((prev) => "predefinedConnection");
                setConnectionDetails((prev) => null);
              }}
            >
              Create Predefined Connection
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0066FF",
                color: "#fff",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#0056d2",
                },
              }}
              onClick={() => {
                setConnection((prev) => "customConnection");
              }}
            >
              Create Custom Connection
            </Button>
          </Box>
        </Box>

        <Box mt={5} sx={{ width: { xl: "80%", md: "70%" } }}>
          <Grid container spacing={2}>
            {connectionList?.map((connectionName) => (
              <Grid
                item
                sm={6}
                md={5}
                lg={3}
                xl={2.3}
                key={connectionName?.data?.connApiName}
                onClick={() => {
                  setConnectionDetails((prev) => connectionName);
                  setConnection((prev) => "details");
                }}
              >
                <Card
                  sx={{
                    maxWidth: 350,
                    height: 190,
                    position: "relative",
                    transition: "box-shadow 0.3s ease-in-out", // Smooth transition for shadow
                    boxShadow: 3, // Initial shadow
                    "&:hover": {
                      boxShadow: 8, // Increased shadow on hover
                    },
                  }}
                >
                  <CardActionArea sx={{ height: "100%" }}>
                    {/* First portion (image or name box) with hover effect */}
                    <Box
                      sx={{
                        position: "relative",
                        height: "64%", // Adjusted height to 64% for the first portion
                        overflow: "hidden",
                        "&:hover::after": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          bgcolor: "rgba(0, 0, 0, 0.4)", // Dark transparent overlay on hover
                          zIndex: 1,
                        },
                        "&:hover .hover-icons": {
                          visibility: "visible", // Show icons on hover
                          zIndex: 2, // Ensure the icons are above the overlay
                        },
                      }}
                    >
                      {connectionName?.service?.name === "ZOHO AUTH" ||
                      connectionName?.service?.name === "crm" ? (
                        <CardMedia
                          sx={{
                            bgcolor: "#F2F7FD",
                            height: "100%",
                            position: "relative",
                          }}
                          component="img"
                          image={
                            connectionName?.service?.name === "ZOHO AUTH"
                              ? zohoPic
                              : connectionName?.service?.name === "crm"
                              ? crmPic
                              : authPic
                          }
                        />
                      ) : (
                        <Box
                          sx={{
                            height: "100%",
                            bgcolor: "#F2F7FD",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "purple",
                              fontSize: "25px",
                              fontWeight: "bold",
                            }}
                          >
                            {connectionName?.service?.name
                              ?.slice(0, 2)
                              .toUpperCase()}
                          </Typography>
                          <Typography>
                            {connectionName?.service?.name || "Service Name"}
                          </Typography>
                        </Box>
                      )}

                      
                    </Box>

                    {/* Divider and remaining content */}
                    <Divider />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 2,
                      }}
                    >
                      <Box
                        sx={{
                          flexGrow: 1,
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Typography sx={{ fontSize: "14px" }}>
                          {connectionName?.data?.connName || "Connection Name"}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontSize: "13px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {connectionName?.data?.connApiName ||
                            "Connection API Name"}
                        </Typography>
                      </Box>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    );
  }

  if (connection === "details") {
    return (
      <ConnectionDetailsView
        connectionDetails={connectionDetails}
        setConnectionDetails={setConnectionDetails}
        setConnection={setConnection}
        dataCenter={dataCenter}
        activeUsers={activeUsers}
        currentUser={currentUser}
        orgId={orgId}
        apiKey={apiKey}
        zApiKey={zApiKey}
        setSnack={setSnack}
        handlefetchConnections={handlefetchConnections}
      />
    );
  }

  if (connection === "customConnection") {
    return (
      <CustomConnection
        setConnection={setConnection}
        dataCenter={dataCenter}
        orgId={orgId}
        apiKey={apiKey}
        zApiKey={zApiKey}
        setSnack={setSnack}
        activeUsers={activeUsers}
        currentUser={currentUser}
        handlefetchConnections={handlefetchConnections}
      />
    );
  }

  if (connection === "predefinedConnection") {
    return (
      <CreateConnection
        setConnection={setConnection}
        dataCenter={dataCenter}
        orgId={orgId}
        apiKey={apiKey}
        zApiKey={zApiKey}
        setSnack={setSnack}
        activeUsers={activeUsers}
        currentUser={currentUser}
        handlefetchConnections={handlefetchConnections}
      />
    );
  }

  if (connection === "edit") {
    return <EditPage setConnection={setConnection} />;
  }

  return <></>;
}

export default ConnectionList;
